import { message } from "antd";
import { createReportSerials } from "../../../services/seriales";


const ExportToExcel = async ({
  setLoading,
  timezone_offset = 0,
  fecha_facturacion_start = null,
  fecha_facturacion_end = null,
  fecha_creacion_start = null,
  fecha_creacion_end = null,
  fecha_order_de_compra_start = null,
  fecha_order_de_compra_end = null,
  vendedor_id = null,
  bodega_id = null,
  grupo_id = null,
  producto_id = null,
  estado_serial_id = null,}) => {
  

  setLoading(true);
  const response = await createReportSerials({
    timezone_offset,
      fecha_facturacion_start,
      fecha_facturacion_end,
      fecha_creacion_start,
      fecha_creacion_end,
      fecha_order_de_compra_start,
      fecha_order_de_compra_end,
      vendedor_id,
      bodega_id,
      grupo_id,
      producto_id,
      estado_serial_id,
  });
console.log(response);
  if (response) {
    if (response.status === 202) {
      message.success("Reporte generado en segundo plano. Ve a reportes para descargar");
      setLoading(false);
    } else if (response.status === 200) {
      message.success("Reporte generado correctamente");
      setLoading(false);
    } else {
      message.warning("Respuesta inesperada del servidor");
      setLoading(false);
    }
  } else {
    message.warning("El reporte se está generando en segundo plano. Por favor ver en reportes para descargar");
    setLoading(false);
  }

};

export default ExportToExcel;
